import { RoyalMailProvider } from '~/lib/consts/providers';
import { ServiceSpeedType } from './PopulateQuoteTags';
import { SettingsCache } from '~/lib/consts/settings-cache';

export function GetColumnHeading(
  serviceType: ServiceSpeedType,
  provider: string,
  recipientCountry: string,
  senderCountry: string
) {
  const dom = recipientCountry === senderCountry;

  // DHL Specific
  if (SettingsCache.profile?.toUpperCase().includes('DHLPARCEL')) {
    switch (serviceType) {
      case 'Fast':
        return 'Drop at Shop';
      case 'Medium':
        return 'Collection';
      case 'Slow':
        return 'Drop at Depot';
      default:
        return serviceType;
    }
  }

  if (provider === RoyalMailProvider) {
    switch (serviceType) {
      case 'Fast':
        return dom ? '24 Hour' : 'Express (1-3 Day Delivery)';
      case 'Medium':
        return dom ? '48 Hour' : 'Economy (3+ Day Delivery)';
      default:
        return 'Other';
    }
  }

  switch (serviceType) {
    case 'Fast':
      return dom ? 'Next Day+ Delivery' : 'Express (1-3 Day Delivery)';
    case 'Medium':
      return dom ? '2 Day+ Delivery' : 'Economy (3+ Day Delivery)';
    case 'Slow':
      return dom ? '3 Day+ Delivery' : 'Super Economy (5+ Day Delivery)';
    default:
      return serviceType;
  }
}
